import Router from 'vue-router'
// 普通用户路由
import adminMenu from "@/public/menuLeft";
  const DynamicRoutes =  [
    {
      path: "",
      name: "adminMenu",
      component: adminMenu,
      redirect:"/sportermeeting",//重定向路由
      meta: {
        requiresAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      children:[
        
      ]
    },
    {
      path: "*",
      redirect: '/gradeLogin',
    }
  ];
  
export {
  DynamicRoutes
}


// WEBPACK FOOTER //
// ./src/router/dynamic.js